import { FormControl } from "@mui/material";
import { styled } from "@mui/system";

export const StyledFormControl = styled(FormControl)({
  "&.Mui-error": {
    "& .filledInput": {
      borderColor: "#ea2b1e"
    }
  }
});

export const StyledTimePickerWrapper = styled("div")(({ theme }) => {
  const light = theme.palette.type === "light";
  const placeholder = {
    color: "#86868b",
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.shorter
    })
  };
  const placeholderHidden = {
    opacity: "0 !important"
  };
  const placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };

  return {
    "& .filledInput": {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "22px",
      letterSpacing: "0.08px",
      color: "#2C2C2C",
      backgroundColor: "#FFF",
      borderRadius: "12px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#BCBDC0",
      padding: 0,
      width: "100%",
      "&:hover": {
        backgroundColor: "#FFF"
      },
      "& .MuiInputBase-root": {
        backgroundColor: "transparent",
        borderRadius: "12px",
        "&.Mui-disabled": {
          background: "#F2F2F2",
          color: "#9B9CA0"
        }
      },
      "& .MuiInputAdornment-root": {
        display: "flex"
      }
    },
    "& .digitalClockSectionItemStyle": {
      "&.Mui-selected": {
        backgroundColor: "#3b3a3a",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#3b3a3a"
        }
      }
    },
    "& .pickersLayoutContentWrapper": {
      "& .MuiTimeClock-root": {
        "& .MuiClock-pin, .MuiClockPointer-root": {
          backgroundColor: "#3b3a3a"
        },
        "& .MuiClockPointer-thumb": {
          backgroundColor: "#3b3a3a",
          border: "16px solid #3b3a3a"
        }
      }
    },
    "& .pickersLayoutActionBar": {
      "& .MuiButtonBase-root": {
        color: "#3b3a3a"
      }
    },
    "& .MuiInputBase-input": {
      padding: "25px 20px 8px",
      "&::placeholder": placeholder,
      "&::-webkit-input-placeholder": placeholder,
      "&::-moz-placeholder": placeholder,
      "&:-ms-input-placeholder": placeholder,
      "&::-ms-input-placeholder": placeholder,
      "label[data-shrink=false] + .MuiInputBase-formControl &": {
        "&::-webkit-input-placeholder": placeholderHidden,
        "&::-moz-placeholder": placeholderHidden,
        "&:-ms-input-placeholder": placeholderHidden,
        "&::-ms-input-placeholder": placeholderHidden,
        "&:focus::-webkit-input-placeholder": placeholderVisible,
        "&:focus::-moz-placeholder": placeholderVisible,
        "&:focus:-ms-input-placeholder": placeholderVisible,
        "&:focus::-ms-input-placeholder": placeholderVisible
      }
    },
    "& .MuiInputLabel-root": {
      color: "var(--Color-Text-Primary-On-Light)",
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0.08px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      transform: "translate(20px, 16px) scale(1)"
    },
    "& .MuiInputLabel-shrink": {
      fontWeight: 500,
      fontSize: "0.875rem",
      transform: "translate(20px, 7px) scale(0.75)",
      color: "var(--colour-text-secondary)"
    },
    "& .MuiIconButton-root": {
      marginRight: 0,
      "& svg": {
        width: "24px",
        height: "24px",
        color: "var(--Color-Text-Primary-On-Light)"
      }
    }
  };
});
